import React from 'react';

function PopupWithoutUseClickOutside(props) {
	const { isPopupVisible = true, onHidePopup, children } = props;

	return (
		<div>
			{isPopupVisible ? (
				<div className="grid grid cols-1">
					<div className="fade absolute top-20 lg:w-1/2 h-auto justify-self-center z-50">
						{children}
					</div>
					<div className="fixed top-0 left-0 w-full h-full bg-black opacity-70 grid grid cols-1 z-25" />
				</div>
			) : null}
		</div>
	);
}

export default PopupWithoutUseClickOutside;
